// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"93c5915f","247":"1bd79b1d","422":"47073963","627":"8b97a726","867":"9a21e9b3","923":"c508a902","938":"db34e815"}[chunkId] + ".chunk.js";
};